module.exports = "<div class=\"forgot-password-dialog-root\">\n  <h3 class=\"confirm-header\">A link for new password has been sent to:</h3>\n  <div class=\"mail\">{{mail}}</div>\n  <md-dialog-actions>\n    <button md-raised-button (click)=\"dialog.close()\">\n      <span>OK</span>\n    </button>\n  </md-dialog-actions>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/confirm-email-sent-dialog/confirm-email-sent-dialog.component.html
// module id = 182
// module chunks = 1